import { AsyncPipe } from '@angular/common'
import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { MenuItem, PrimeTemplate } from 'primeng/api'
import { Menu } from 'primeng/menu'
import { Ripple } from 'primeng/ripple'
import { map, Observable } from 'rxjs'

import { UserAuthMethod } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { LogoutStrategy } from '@ti/core/auth/services'
import { AuthSession } from '@ti/core/auth/services/auth.session'
import { Profile } from '@ti/core/auth/services/my.profile'
import { Memoize } from '@ti/core/common/decorators'
import { APP_VERSION } from '@ti/core/contracts/version'
import { LanguageIconComponent } from '@ti/core/icons/language/language-icon.component'
import { PencilIconComponent } from '@ti/core/icons/pencil/pencil-icon.component'
import { SignOutIconComponent } from '@ti/core/icons/sign-out/sign-out-icon.component'
import { LanguageService } from '@ti/core/ui-kit/i18n'
import { AvatarComponent } from '@ti/core/ui-kit/layout/components/avatar/avatar.component'
import { DynamicHostComponent } from '@ti/core/ui-kit/layout/components/dynamic-host/dynamic-host.component'

@Component({
  selector: 'app-personal-menu',
  templateUrl: 'personal-menu.component.html',
  styleUrls: ['personal-menu.component.scss'],
  imports: [
    AsyncPipe,
    AvatarComponent,
    DynamicHostComponent,
    Menu,
    PrimeTemplate,
    Ripple,
    TranslatePipe,
  ],
})
export class PersonalMenuComponent {
  @Output() languageClicked = new EventEmitter<void>()
  @Output() settingsClicked = new EventEmitter<void>()

  protected readonly api = inject(ApiService)
  protected readonly authSession = inject(AuthSession)
  protected readonly logoutStrategy = inject(LogoutStrategy)
  protected readonly languageService = inject(LanguageService)
  protected readonly profile = inject(Profile)
  protected readonly router = inject(Router)
  protected readonly version = inject(APP_VERSION)

  protected TYPES = { UserAuthMethod }

  @ViewChild('menuRef')
  protected menuRef!: Menu

  @Memoize()
  protected get menuItems$(): Observable<MenuItem[]> {
    return this.languageService
      .massTranslate$({
        accountSettings: 'users.profile.edit-profile',
        language: 'common.language',
        signOut: 'button.sign-out',
      })
      .pipe(
        map((labels) => {
          return [
            {
              iconType: PencilIconComponent,
              label: labels.accountSettings,
              command: () => this.settingsClicked.emit(),
            },
            {
              iconType: LanguageIconComponent,
              label: labels.language,
              command: () => this.languageClicked.emit(),
            },
            {
              iconType: SignOutIconComponent,
              label: labels.signOut,
              cssClass: 'color-custom alert',
              command: async () => {
                return this.logoutStrategy.signOut()
              },
            },
          ]
        }),
      )
  }

  public toggle(event: MouseEvent) {
    return this.menuRef.toggle(event)
  }
}
